import { GlobalLayout as Layout } from '@components/layout/PageLayout'
import { FiltersDrawer } from '@components/search/filters'
import Seo, { reformStoreFromHeaders } from '@components/seo/seo'
import PageHeroSection from '@components/ui/page-hero-section'
import { GetServerSidePropsContext } from 'next'
import { useState } from 'react'

import {
  Box,
  Button,
  Flex,
  SimpleGrid,
  Spinner,
  Text,
  useDisclosure,
} from '@chakra-ui/react'
import { productGrids } from '@components/product/component-options'
import ProductSortFilter, {
  useProductSortFilter,
} from '@components/product/product-sort-filter'
import { useStore } from '@contexts/store'
import { useBannerMedia } from '@helper/getBannerMedia'
import { AiOutlineTag } from 'react-icons/ai'

export function Products() {
  const { storeData: shop, storeTemplate } = useStore()
  const { isOpen, onOpen, onClose } = useDisclosure()

  const [numberOfProductsFound, setNumberofProductsFound] = useState<
    number | undefined
  >()

  const { media } = useBannerMedia()

  const { productFilter, handleProductFilter } = useProductSortFilter()

  const ThemeProductGrid = productGrids[storeTemplate]

  return (
    <>
      <Seo
        title={`${shop?.name} | All Products`}
        description="Browse all products on our store"
        path="/products"
        site_url={shop?.url}
      />
      <PageHeroSection banner={media} heroTitle={'All Products'} />
      <Flex
        direction={{ base: 'column', lg: 'row' }}
        pl={{ base: '4', lg: '8' }}
        pe={{ base: '4', lg: '10' }}
        gap={{ base: '4', lg: '6' }}
        mt="4"
        mb={{ base: '6', lg: '10' }}
      >
        <Box minW="20%" w="20%" alignSelf="start" position="sticky" top="100px">
          <FiltersDrawer
            numberOfProductsFound={numberOfProductsFound}
            shopId={shop?._id}
            isDrawerOpen={isOpen}
            onDrawerClose={onClose}
          />
        </Box>

        <Flex direction="column" flexGrow="1">
          <SimpleGrid
            columns={[1, 2]}
            gap="1"
            alignItems="center"
            justifyContent="space-between"
          >
            <Button
              width="max-content"
              bg="transparent"
              mx={['auto', '0']}
              display={{ base: 'flex', lg: 'none' }}
              onClick={onOpen}
              alignItems="center"
              fontSize="14px"
              fontWeight="400"
            >
              <Box as={AiOutlineTag} color="brand" />
              <Text pl={'2.5'}>Tags</Text>
            </Button>

            {numberOfProductsFound !== undefined ? (
              <Text display={{ base: 'none', lg: 'inline' }}>
                {numberOfProductsFound} Item
                {numberOfProductsFound > 1 ? 's' : ''} Found
              </Text>
            ) : (
              <Spinner size="sm" display={{ base: 'none', lg: 'inline' }} />
            )}

            <Flex justify={['center', 'end']}>
              <ProductSortFilter
                handleProductFilter={handleProductFilter}
                styleProps={{ display: 'flex', justifyContent: "center" }}
              />
            </Flex>
          </SimpleGrid>

          <ThemeProductGrid
            productFilter={productFilter}
            setNumberofProductsFound={setNumberofProductsFound}
          />
        </Flex>
      </Flex>
      {/* <DownloadApps /> */}
    </>
  )
}

Products.Layout = Layout
export const getServerSideProps = async (ctx: GetServerSidePropsContext) => {
  const storeDetails = reformStoreFromHeaders(ctx)
  return {
    props: {
      pageProps: {
        storeDetails,
      },
    },
  }
}

export default Products
